<template>
  <div class="specialty-page">
    <div class="specialty">
      <CollegeSpecialty></CollegeSpecialty>
    </div>
    <div class="demand">
      <CollegeDemand></CollegeDemand>
    </div>

    <div class="shuangyiliu">
      <div class="title">双一流学科</div>
      <span class="specialty_name" v-for="(item, i) in shuangyiliuList" :key="i">
        {{ item.specialty_name }}
      </span>
    </div>

    <div class="shuangyiliu">
      <div class="title">重点学科</div>
      <span class="specialty_name" v-for="(item, i) in importantSpecialtyList" :key="i">
        {{ item.specialty_name }}
      </span>
    </div>
  </div>
</template>

<script>
import CollegeSpecialty from './components/CollegeSpecialty.vue';
import CollegeDemand from './components/CollegeDemand.vue';
export default {
  name: '',
  components: {
    CollegeSpecialty, CollegeDemand
  },
  data() {
    return {
      shuangyiliuList: null,
      importantSpecialtyList: null
    };
  },
  created() {
    this.$parent.cat = 1
    this.getShuang()
    this.getImportant()
  },
  computed: {
  },
  methods: {
    getShuang() {
      this.$fecth
        .get("school/getShuang", { params: { school_id: this.$route.query.cid } })
        .then((res) => {
          this.shuangyiliuList = res
        });
    },
    getImportant() {
      this.$fecth
        .get("school/getImportant", { params: { school_id: this.$route.query.cid } })
        .then((res) => {
          this.importantSpecialtyList = res
        });
    }
  },
};
</script>

<style scoped lang='less'>
.specialty-page {
  width: 1400px;
  margin: 0 auto;
  padding-bottom: 40px;
  vertical-align: top;

  .specialty {
    background: white;
    height: 600px;
    width: 759px;
    padding-left: 100px;
    display: inline-block;
    margin-right: 7px;
    vertical-align: top;
    padding-top: 30px;
  }

  .demand {
    background: white;
    height: 610px;
    width: 433px;
    padding-right: 100px;
    display: inline-block;
    vertical-align: top;
    padding-top: 20px;

  }

  .shuangyiliu {
    background: white;
    margin-top: 8px;
    padding: 30px 100px;

    .title {
      font-size: 22px;
    }

    .specialty_name {
      background: #F5F5F5;
      display: inline-block;
      margin-top: 20px;
      margin-right: 20px;
      padding: 2px 5px;
      border-radius: 3px;
    }
  }
}
</style>
